import React, { useState, useRef } from 'react';
import './registeruser.css';

// set dependecies
    import { firebase } from '../../../firebase';
    import { FaUpload } from 'react-icons/fa';
    import { Redirect } from 'react-router-dom';

const RegisterUser = () => {

    // set USEREF
    const fileInput = useRef(null);

    // set usestates hooks
        const [file, setFile] = useState(null);
        const [image, setImage] = useState('');
        const [showImage, setShowImage] = useState(null);
        const [loading, setLoading] = useState(false);
        const [redirect, setRedirect] = useState(false);
        const [change, setChange] = useState({
            usuario: '',
            password: '',
            nome: '',
            sobrenome: '',
            image: '',
            nomecompleto: '',
        })

    // set handle image
        const handleImage = e => {
            setFile(e.target.files[0]);
            setImage(e.target.files[0].name);
            setShowImage(URL.createObjectURL(e.target.files[0]))
        }

    // set handlechange
        const handlechange = e => {
            const { name, value } = e.target;
            setChange(prevState => ({
                ...prevState,
                [name] : value
            }))
        }
    

    const save = e => {
        e.preventDefault();
        setLoading(true);
            const getAllData = firebase.storage().ref(`imageUser/${file.name}`).put(file);
            getAllData.on("state_changed", console.log, console.erro, () => {
                firebase.storage()
                    .ref('imageUser')
                        .child(file.name)
                            .getDownloadURL()
                                .then(url => {
                                    let data = {
                                        usuario: change.usuario,
                                        senha: change.senha,
                                        nome: change.nome,
                                        sobrenome: change.sobrenome,
                                        image: url,
                                        nomecompleto: change.nomecompleto,
                                        data: new Date().toLocaleString('pt', {day: 'numeric', month: 'long', year: 'numeric'}),
                                        hora: `${new Date().getHours()}:${new Date().getMinutes()}`
                                    }
                                    const saveDatauser = firebase.firestore().collection('usuarios').doc();
                                    saveDatauser.set(data);
                                    setRedirect(true);
                                    setLoading(false);
                                })
            })
    }

    if(redirect) {
        return <Redirect to={'/home/lista-usuarios'} />
    }

    return (
        <div className={'registeruser container d-flex justify-content-center'}>
            {
                loading
                ?
                <div className={'save-loading d-flex justify-content-center'}>
                    <img alt={'user-perfil'} className={'loading-gif'} src={'https://raw.githubusercontent.com/Codelessly/FlutterLoadingGIFs/master/packages/circular_progress_indicator.gif'} />
                </div>
                :
                <form onSubmit={ e => save(e) } className={'box-form'}>
                    <p className={'reg-client'}>Por favor, preencha todos os campos para cadastrar o usuário</p>
                    <p className={'data-user'}>Dados do usuário</p>
                    <div className={'d-flex justify-content-center box-data-user wrap'}>
                        <div className={'box-input-data'}>
                            <div className={'box-input-data-user'}>
                                <p className={'name-user'}>Usuário*</p>
                                <input onChange={handlechange} required name={'usuario'} id={'input-user1'} className={'form-control shadow-none'} placeholder={'Ex: user'} />
                            </div>
                            <div className={'box-input-data-user'}>
                                <p className={'name-user'}>Senha*</p>
                                <input onChange={handlechange} type={'password'} required id={'input-user2'} name={'senha'} className={'form-control shadow-none'} placeholder={'Ex: ******'}  />
                            </div>
                        </div>
                        <div className={'box-input-data'}>
                            <div className={'box-input-data-user'}>
                                <p className={'name-user'}>Nome*</p>
                                <input onChange={handlechange} required id={'input-user3'} name={'nome'} className={'form-control shadow-none'} placeholder={'Ex: Leandro'} />
                            </div>
                            <div className={'box-input-data-user'}>
                                <p className={'name-user'}>sobrenome*</p>
                                <input onChange={handlechange} required id={'input-user4'} name={'sobrenome'} className={'form-control shadow-none'} placeholder={'Ex: Martins'}  />
                            </div>
                        </div>
                        <div>
                            <div className={'d-flex justify-content-start box-img-perfil wrap'}>
                                <div>
                                    <img className={'img-perfil-user'} src={showImage?showImage:null} alt={showImage} /><br/>
                                </div>
                                <div>
                                    <input type={'file'} onChange={handleImage} ref={fileInput} style={{display: 'none'}} />
                                    <small className={'img-name'}> {image} </small><br/>
                                    <button onClick={() => fileInput.current.click()} type={'button'} className={'btn btn-outline-dark shadow-none'} style={{borderRadius: 60}}><FaUpload/> Upload</button>
                                    <div className={'box-input-data-user'}>
                                        <p className={'name-user'}>nome completo*</p>
                                        <input onChange={handlechange} required name={'nomecompleto'} id={'input-data-user'} className={'form-control shadow-none'} placeholder={'Ex: Leandro matis da silva'}  />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={'d-flex justify-content-end'} style={{width: '100%'}}>
                        <button disabled={!file} type={'submit'} className={'btn'} id={'btn-save_'}>
                            Salvar
                        </button>
                    </div>
                </form>
            }
        </div>
    )
}

export default RegisterUser;